var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleSettingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6 0C6.421 0 .6 5.821.6 13s5.821 13 13 13 13-5.821 13-13-5.821-13-13-13zm4.846 18.386c-1.178 1.085-2.786 1.723-4.704 1.723A7.104 7.104 0 016.636 13c0-1.15.275-2.234.757-3.195a7.102 7.102 0 016.35-3.917c1.914 0 3.522.705 4.755 1.851l-2.037 2.04c-.737-.705-1.674-1.062-2.716-1.062-1.851 0-3.418 1.25-3.978 2.93A4.275 4.275 0 009.543 13c0 .47.082.926.224 1.352.56 1.68 2.127 2.931 3.975 2.931.958 0 1.77-.252 2.406-.679a3.268 3.268 0 001.419-2.147h-3.825v-2.751h6.695c.084.467.127.952.127 1.454 0 2.167-.774 3.987-2.118 5.226z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleSettingIcon);
export default __webpack_public_path__ + "static/media/google-setting-icon.a9218561f8676d83cfe28d37a6189c2c.svg";
export { ForwardRef as ReactComponent };